import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { Button } from '@fiverr-private/button';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { Container, Section, Stack } from '@fiverr-private/layout_components';
import { SearchBar } from '@fiverr-private/search_bar';
import { theme } from '@fiverr-private/theme';
import { Typography } from '@fiverr-private/typography';
import { CalendarIcon } from '@fiverr-private/visuals';
import SafeComponent from '../../shared/SafeComponent';
import { navigateToMiraEntry } from '../../utils/mira';
import { MiraSparkIcon } from '../HeroSearch/MiraSparkIcon';
import { CONTACT_SALES_URL, getCopyKey } from './config';
import { MIRA_PROMPT, MIRA_SOURCE, MIRA_VARIATION, QUICK_ACTIONS_COPY_PREFIX, SEARCH_BAR_SOURCE } from './constants';
import QuickActionCard from './QuickActionCard';
import { sectionClass, titleClass } from './styles.ve.css';

const QuickActions = () => {
    const isBelowSm = useMediaQuery({ query: theme.breakpointsReverse.sm });
    const isBelowMd = useMediaQuery({ query: theme.breakpointsReverse.md });

    const onMiraClick = () =>
        navigateToMiraEntry({
            prompt: MIRA_PROMPT,
            source: MIRA_SOURCE,
            guest: true,
            variation: MIRA_VARIATION,
        });

    return (
        <Section paddingTop={{ default: '8', md: '10' }} paddingBottom={{ default: '8', md: '10' }}>
            <Stack
                className={sectionClass}
                direction="column"
                gap={{ default: '8', md: '10' }}
                borderRadius="2xl"
                paddingX={{ default: '6', sm: '8' }}
                paddingY={{ default: '8', sm: '10', md: '14' }}
            >
                <Typography as="h2" color="grey_1200" className={titleClass}>
                    <I18n k={getCopyKey('title', isBelowSm)} />
                </Typography>
                <Stack direction={{ default: 'column', md: 'row' }} gap={{ default: '4', md: '6' }}>
                    <QuickActionCard copyKey="search" isMobileCopy={isBelowMd}>
                        <Container width="100%">
                            <SearchBar
                                placeholder={translate<string>(getCopyKey('search.placeholder', isBelowMd))}
                                source={SEARCH_BAR_SOURCE}
                            />
                        </Container>
                    </QuickActionCard>
                    <QuickActionCard copyKey="mira" isMobileCopy={isBelowMd}>
                        <Button size="sm" variant="outline" onClick={onMiraClick}>
                            <MiraSparkIcon size={16} />
                            <I18n k={`${QUICK_ACTIONS_COPY_PREFIX}.mira.cta`} />
                        </Button>
                    </QuickActionCard>
                    <QuickActionCard copyKey="contact_sales" isMobileCopy={isBelowMd}>
                        <Button size="sm" variant="outline" href={CONTACT_SALES_URL}>
                            <CalendarIcon />
                            <I18n k={`${QUICK_ACTIONS_COPY_PREFIX}.contact_sales.cta`} />
                        </Button>
                    </QuickActionCard>
                </Stack>
            </Stack>
        </Section>
    );
};

export { QuickActions };
export default SafeComponent(QuickActions);
